import AOS from 'aos';

export default function initAOS() {
  AOS.init({ duration: 1200 });
}
